import DashboardOIGSAM from "./DashboardOIGSAM";

export default DashboardOIGSAM;
